import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
export const SPEND_CATEGORIES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SPEND_CATEGORIES');
export const SPEND_CATEGORIES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SPEND_CATEGORIES_CRUD_ACTION_CONSTANTS
);
